import { Link, useLocation } from 'react-router-dom';

const MAKEUP_SHOP_MENUS = [
  { path: '/makeup-shop/customers', label: '고객관리', icon: 'ri-user-3-line' },
  { path: '/makeup-shop/schedules', label: '일정관리', icon: 'ri-calendar-check-line' },
  { path: '/makeup-shop/artist-grid', label: '아티스트현황', icon: 'ri-team-line' },
  { path: '/makeup-shop/settlements', label: '정산관리', icon: 'ri-exchange-line' },
  { path: '/makeup-shop/inventory', label: '재고관리', icon: 'ri-archive-line' },
];

export default function MakeupShopNav() {
  const location = useLocation();

  const isActive = (path: string) =>
    location.pathname === path || location.pathname.startsWith(path + '/') ||
    (path === '/makeup-shop/customers' && location.pathname.startsWith('/makeup-shop/customer-detail'));

  return (
    <div className="bg-white border-b border-gray-200 mb-6 -mx-8 -mt-8 px-8 pt-4">
      <div className="flex items-center gap-1 mb-0">
        <span className="text-sm font-bold text-gray-800 mr-4">메이크업</span>
        {MAKEUP_SHOP_MENUS.map((menu) => (
          <Link
            key={menu.path}
            to={menu.path}
            className={`px-3 py-3 text-sm font-medium border-b-2 transition-colors ${
              isActive(menu.path)
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-800 hover:border-gray-300'
            }`}
          >
            <i className={`${menu.icon} mr-1.5`}></i>
            {menu.label}
          </Link>
        ))}
      </div>
    </div>
  );
}
